export default function Terms() {
  return (
    <div className="app static-page">
      <header>
        <h1>Terms of Service</h1>
      </header>

      <section className="static-content">
        <p>
          Edge Finder provides AI-generated suggestions to help you compare your resume
          against a job description. The output is informational only and is not a
          guarantee of any outcome.
        </p>

        <p>
          You are solely responsible for what you choose to add to, remove from, or
          change in your resume. Do not include suggested content unless it is truthful
          and accurately reflects your real experience.
        </p>

        <p>
          We make no warranty about whether using Edge Finder will help you get an
          interview, an offer, or any other result. We are not liable for hiring
          decisions, application outcomes, or any consequences of using this tool.
        </p>

        <p>
          By using Edge Finder you agree to these terms.
        </p>

        <p>
          <a href="#/">← Back to Edge Finder</a>
        </p>
      </section>
    </div>
  );
}
